import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class LBASuperUserService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}').replace('{version}', this.version);

    constructor(private http: HttpClient) {}

    getLBAUsers(): Observable<any[]> {
        return this.http.get<any[]>(`${this._url}/superuser`);
    }

    addLBAUser(params): Observable<any> {
        const data = {
            loginEmail: params.loginEmail,
            isSuperUser: params.isSuperAdmin,
            isDemoUser: params.isDemoUser,
            isActive: params.isActive,
            isPlatformUser: params.isPlatformUser,
        };
        return this.http.post<any>(`${this._url}/superuser`, data);
    }

    updateUser(params) {
        const data = {
            loginEmail: params.loginEmail,
            isSuperUser: params.isSuperAdmin,
            isPlatformUser: params.isPlatformUser,
            isDemoUser: params.isDemoUser,
            isActive: params.isActive,
        };

        return this.http.patch(`${this._url}/superuser/`, data);
    }

    getAllPlatformUsers(requestType: string): Observable<IUserShort[]> {
        const data = { requestType: requestType };
        return this.http.post<IUserShort[]>(`${this._url}/superuser/GetAllPlatformUsers/`, data);
    }
}

export interface IUserShort {
    userKey?: string;
    clientFullname?: string;
    lfName?: string;
    loginEmail?: string;
    userType?: string;
    isActive?: boolean;
    lastLoginDate?: Date;
}
